// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicePriorities_ClonarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/service_priorities/clonar
 *
 * Clone selected service-priority rows to a different franchise.
 */
import { registerContract } from './validate'

export interface ServicePriorities_ClonarInput {
ids: number[]
target_franchise_id: number
}

registerContract('ServicePriorities_ClonarInput', {
  ids:                 { type: 'array',   required: true },
  target_franchise_id: { type: 'number',  required: true },
})
